import { RolesEnum } from '../types/RolesEnum';
import { canonicalizeSpecialistRoleName } from './specialistRoleModuleHelper';

const DEFAULT_TONE = { bg: '#e2e8f0', fg: '#334155', border: '#cbd5e1', accent: '#64748b' };

const ROLE_TONES = {
  [RolesEnum.SPECIALIST_FEEDER]: { bg: '#ccfbf1', fg: '#115e59', border: '#5eead4', accent: '#0f766e' },
  [RolesEnum.SPECIALIST_PRE_MANAGER]: { bg: '#e0e7ff', fg: '#3730a3', border: '#a5b4fc', accent: '#4f46e5' },
  [RolesEnum.SPECIALIST_MANAGER]: { bg: '#dbeafe', fg: '#1e3a8a', border: '#93c5fd', accent: '#1d4ed8' },
  [RolesEnum.SPECIALIST_VALIDATOR]: { bg: '#fef3c7', fg: '#92400e', border: '#fcd34d', accent: '#b45309' },
  [RolesEnum.SPECIALIST_VERIFICATOR]: { bg: '#fef3c7', fg: '#92400e', border: '#fcd34d', accent: '#b45309' },
  [RolesEnum.SPECIALIST_EDITOR]: { bg: '#ffe4e6', fg: '#9f1239', border: '#fda4af', accent: '#be123c' },
  [RolesEnum.SPECIALIST_COORDINATOR]: { bg: '#ede9fe', fg: '#5b21b6', border: '#c4b5fd', accent: '#7c3aed' },
  [RolesEnum.SPECIALIST_LIAISON]: { bg: '#ffedd5', fg: '#9a3412', border: '#fdba74', accent: '#c2410c' }
};

const PHASE_TONES = {
  FASE_1_PROGRAMACION_PREVIA: { bg: '#e2e8f0', fg: '#0f172a', border: '#94a3b8', accent: '#334155' },
  FASE_2_EXPLORACION: { bg: '#cffafe', fg: '#155e75', border: '#67e8f9', accent: '#0e7490' },
  FASE_3_RELEVAMIENTO: { bg: '#dcfce7', fg: '#166534', border: '#86efac', accent: '#15803d' },
  FASE_4_LIMPIEZA_DATOS: { bg: '#fef9c3', fg: '#854d0e', border: '#fde047', accent: '#a16207' },
  FASE_5_EDICION: { bg: '#ffedd5', fg: '#9a3412', border: '#fdba74', accent: '#c2410c' },
  FASE_6_ACTUALIZACION: { bg: '#ffe4e6', fg: '#9f1239', border: '#fda4af', accent: '#be123c' }
};

const MODULE_TONES_BY_ID = {
  1: { bg: '#dbeafe', fg: '#1e40af', border: '#93c5fd', accent: '#2563eb' },
  2: { bg: '#d1fae5', fg: '#065f46', border: '#6ee7b7', accent: '#059669' },
  3: { bg: '#ffedd5', fg: '#9a3412', border: '#fdba74', accent: '#ea580c' },
  4: { bg: '#fce7f3', fg: '#9d174d', border: '#f9a8d4', accent: '#db2777' },
  5: { bg: '#ede9fe', fg: '#5b21b6', border: '#c4b5fd', accent: '#7c3aed' },
  6: { bg: '#ccfbf1', fg: '#115e59', border: '#5eead4', accent: '#0f766e' },
  7: { bg: '#e0f2fe', fg: '#075985', border: '#7dd3fc', accent: '#0284c7' },
  8: { bg: '#f1f5f9', fg: '#334155', border: '#cbd5e1', accent: '#64748b' }
};

const MODULE_TONES_BY_KEY = {
  technology: MODULE_TONES_BY_ID[1],
  alternative: MODULE_TONES_BY_ID[2],
  experience: MODULE_TONES_BY_ID[3],
  innovation: MODULE_TONES_BY_ID[4],
  assistance: MODULE_TONES_BY_ID[5],
  financial: MODULE_TONES_BY_ID[6],
  vision: MODULE_TONES_BY_ID[7],
  regulation: MODULE_TONES_BY_ID[8]
};

const ALL_MODULES_TONE = { bg: '#f8fafc', fg: '#0f172a', border: '#94a3b8', accent: '#334155' };

export const getGuideRoleTone = (role = {}) => {
  const name = canonicalizeSpecialistRoleName(role.name || role.catalogrole_name || '');
  return ROLE_TONES[name] || DEFAULT_TONE;
};

export const getGuidePhaseTone = (phase) => {
  const key = String(phase || '').trim();
  return PHASE_TONES[key] || DEFAULT_TONE;
};

export const getGuideModuleTone = (moduleItem = {}) => {
  const id = Number(moduleItem.catalogmodule_id || moduleItem.id);
  if (MODULE_TONES_BY_ID[id]) {
    return MODULE_TONES_BY_ID[id];
  }
  const key = String(moduleItem.key || moduleItem.name || '').trim().toLowerCase();
  return MODULE_TONES_BY_KEY[key] || DEFAULT_TONE;
};

export const getAllModulesTone = () => ALL_MODULES_TONE;

export const getGuideAccentTone = (guide = {}) => {
  if (guide.guide_phase) {
    return getGuidePhaseTone(guide.guide_phase);
  }
  const firstRole = (guide.roles || [])[0];
  if (firstRole) {
    return getGuideRoleTone(firstRole);
  }
  return DEFAULT_TONE;
};
